import PaginatedTable from './PaginatedTable';
export default PaginatedTable;
